var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column col-6 col-sm-12"},[_c('maintenance')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }